module.exports = __webpack_public_path__ + "static/media/checkmark-green.e1b6008e.svg";